import type { EnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { authInterceptor } from '../auth/auth.interceptor';
import { tenantInterceptor } from '../tenant/tenant.interceptor';
import { traceIdInterceptor } from './trace-id.interceptor';
import { retryInterceptor } from './retry.interceptor';
import { httpErrorInterceptor } from './http-error.interceptor';
import { authRefreshInterceptor } from './auth-refresh.interceptor';

/**
 * HttpClient con la cadena de interceptores funcionales.
 *
 * ORDEN (importa — se ejecutan de arriba a abajo en request, inverso en response):
 *  1. traceId     → genera X-Trace-Id (lo necesitan retry/error para correlacionar)
 *  2. auth        → bearer del JWT
 *  3. tenant      → header de correlación / impersonación
 *  4. retry       → reintenta GET idempotentes (backoff+jitter) antes de fallar
 *  5. error       → mapea el error final a toast (queda más cerca del origen)
 *  6. authRefresh → 401 → refresh + retry. ÚLTIMO a propósito: es el PRIMERO en
 *     ver la respuesta, así un 401 recuperado nunca sube al error interceptor
 *     (nada que toastear) ni al retry (que además no reintenta 401, con lo cual
 *     sus reintentos de 5xx/red tampoco pueden duplicar refreshes).
 */
export function provideCoreHttp(): EnvironmentProviders {
  return provideHttpClient(
    withInterceptors([
      traceIdInterceptor,
      authInterceptor,
      tenantInterceptor,
      retryInterceptor,
      httpErrorInterceptor,
      authRefreshInterceptor,
    ]),
  );
}
